
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"17","viewBox":"0 0 16 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.231 6.28c-.2.279-.372.58-.508.899a3.343 3.343 0 10-1.044 6.519h5.348a4.658 4.658 0 002.737-.884l-.962-.963a3.327 3.327 0 01-1.775.51H4.68a2.006 2.006 0 11.627-3.912 1.337 1.337 0 001.646-.744c.069-.161.15-.315.242-.461L6.23 6.28zM12.77 10.929a3.343 3.343 0 00-4.654-4.654L7.16 5.32a4.68 4.68 0 016.566 6.566l-.956-.956z","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.532 2.529a.669.669 0 01.946 0L14.51 14.562a.669.669 0 01-.945.946L1.532 3.474a.669.669 0 010-.945z","fill":"currentColor"}})])
          )
        }
      }
    